// extracted by mini-css-extract-plugin
module.exports = {"button":"_bS","button_primary":"_bT","button_transparent":"_bU","button_default":"_bV"};